import { isHardcodedEpaGulfThreatNotification } from './epaGulfThreatNotification';
import { isFacilityDemoNotificationId } from './facilityDemoPack';
import { isHardcodedFemaThunderboltInvite } from './femaThunderboltInvite';
import { isHardcodedHeleneConeNotification } from './heleneConeNotification';
import { isHardcodedMemphisThreatNotification } from './memphisThreatNotification';
import { isHardcodedUscgFocSeThreatNotification } from './uscgFocSoutheastThreatNotification';

const archivedDemoIds = new Set<string>();

export function isHardcodedInboxNotificationId(id: string): boolean {
  return (
    isHardcodedMemphisThreatNotification(id) ||
    isHardcodedEpaGulfThreatNotification(id) ||
    isFacilityDemoNotificationId(id) ||
    isHardcodedHeleneConeNotification(id) ||
    isHardcodedFemaThunderboltInvite(id) ||
    isHardcodedUscgFocSeThreatNotification(id)
  );
}

export function archiveDemoNotificationId(id: string): void {
  archivedDemoIds.add(id);
}

export function isDemoNotificationArchived(id: string): boolean {
  return archivedDemoIds.has(id);
}

export function applyDemoArchiveState<
  T extends {
    notificationId: string;
    archived: boolean;
    archivedAt: string | null;
  },
>(item: T, archivedAt = new Date().toISOString()): T {
  if (!isDemoNotificationArchived(item.notificationId)) return item;
  return {
    ...item,
    archived: true,
    archivedAt: item.archivedAt ?? archivedAt,
  };
}

/** Test-only reset for the session set. */
export function clearDemoNotificationArchive(): void {
  archivedDemoIds.clear();
}
